/** Confirm 清参走 replaceState，不更新 useLocation，故读 window.location.search */
export default function useInitialCheckAllCountries() {
  const urlSearchParams = new URLSearchParams(
    typeof window !== 'undefined' ? window.location.search : '',
  );
  return decodeURIComponent(urlSearchParams.get('isCheckAllCountries') || '0') === '1';
}
